import axios from 'axios';
import { createSignedGetRequest } from 'utils/createSignedRequestsHelpers';

/**
 * Fetches a single project by id (name, projectKey, ...). Used by the activity-log
 * dialog to show project details when a row is expanded.
 */
export const getProjectById = async (projectId, activeEmployerInfo = {}) => {
  const apiPath = `projects/${projectId}`;

  const signedRequest = await createSignedGetRequest({
    apiPath,
    activeEmployerInfo,
  });

  const response = await axios(signedRequest);

  return response.data;
};
